module.exports = __webpack_public_path__ + "img/pin-regular-alternate.3fdea469.svg";